import _ from 'lodash';
import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared/notify';

import fetch from '../../fetch';

const LayerControls = (name) => require('../../../controls').get(name);
const LayerInfo = (name) => require('../../../info').get(name);

const points = (() => {
    const _handleResponse = (message) => {
        LayerInfo('CreatePoint').reset();

        if (LayerControls('ServiceArea').check()) {
            LayerControls('ServiceArea').getLayer().clear();
        }

        if (LayerControls('Dealerships').check()) {
            LayerControls('Dealerships').getLayer().reset();
        }

        if (LayerControls('Competitors').check()) {
            LayerControls('Competitors').getLayer().reset();
        }

        if (LayerControls('StoreInactive').check()) {
          LayerControls('StoreInactive').getLayer().reset();
        }

        if (LayerControls('PointOfInterest').check()) {
            LayerControls('PointOfInterest').getLayer().reset();
        }

        if (message.type === NOTIFY_TYPE.SUCCESS) {
            notifySuccess(message);
        } else {
            notifyError(message);
        }
    };

    const reporting = req => {
        const _error = xhr => {
            _handleResponse(xhr);
        };

        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Loja reportada com sucesso.' };
            _handleResponse(message);
        };

        return fetch({
            url: `${environment.get('API_HOST')}/loja/ReportarFechamento`,
            type: 'POST',
            processData: false,
            contentType: false,
            data: req,
            error: _error
        }).then(_success);
    };

    const compare = req => {
        return fetch({
            type: 'PUT',
            url: `${environment.get('API_HOST')}/api/loja/ObterMulticriterio`,
            data: {
                id: _.map(req, f => f.properties.Id)
            }
        });
    };

    return {
        compare,
        reporting,
    };
})();

export default points;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/points/index.js